import { render, staticRenderFns } from "./EditJournalList.vue?vue&type=template&id=cbf3adee"
import script from "./EditJournalList.vue?vue&type=script&lang=js"
export * from "./EditJournalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports